import { useEffect, useState } from "react";
import { t } from "../i18n";
import { Bell, BellOff, Send } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "../lib/api";

const b64ToU8 = (s) => { const b = (s + "=".repeat((4 - (s.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"); return Uint8Array.from(atob(b), (c) => c.charCodeAt(0)); };
const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
const standalone = window.navigator.standalone === true || window.matchMedia("(display-mode: standalone)").matches;

export function PushSettings() {
  const supported = "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
  const [sub, setSub] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!supported) return;
    navigator.serviceWorker.ready.then((reg) => reg.pushManager.getSubscription()).then(setSub).catch(() => {});
  }, [supported]);

  const activar = async () => {
    setBusy(true);
    try {
      const perm = await Notification.requestPermission();
      if (perm !== "granted") { toast.error(t("push.denied")); return; }
      const reg = await navigator.serviceWorker.ready;
      const { data } = await api.get("/push/vapid-public-key");
      const s = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToU8(data.public_key) });
      await api.post("/push/subscribe", s.toJSON());
      setSub(s); toast.success(t("push.enabled"));
    } catch (err) { toast.error(errorMessage(err, t("push.enableFail"))); } finally { setBusy(false); }
  };
  const desactivar = async () => {
    setBusy(true);
    try { await api.delete("/push/subscribe", { data: sub.toJSON() }); await sub.unsubscribe(); setSub(null); toast.success(t("push.disabled")); }
    catch (err) { toast.error(errorMessage(err)); } finally { setBusy(false); }
  };
  const prueba = async () => {
    try { const { data } = await api.post("/push/test"); toast.success(t("push.testSent", { n: data.enviados })); } catch (err) { toast.error(errorMessage(err)); }
  };

  if (isIOS && !standalone) return <p data-testid="push-status" className="text-sm text-muted-foreground">{t("push.iosInstall")}</p>;
  if (!supported) return <p data-testid="push-status" className="text-sm text-muted-foreground">{t("push.unsupported")}</p>;
  return (
    <div className="space-y-2">
      <p data-testid="push-status" className="text-sm flex items-center gap-2">{sub ? <><Bell size={16} className="text-[#d4af37]" /> {t("push.on")}</> : <><BellOff size={16} className="text-muted-foreground" /> {t("push.off")}</>}</p>
      {sub ? (
        <div className="grid grid-cols-2 gap-2">
          <button data-testid="push-test-btn" onClick={prueba} className="btn-ghost text-sm flex items-center justify-center gap-2"><Send size={14} /> {t("push.sendTest")}</button>
          <button data-testid="push-disable-btn" onClick={desactivar} disabled={busy} className="btn-ghost text-sm">{t("push.disable")}</button>
        </div>
      ) : <button data-testid="push-enable-btn" onClick={activar} disabled={busy} className="btn-ghost w-full text-sm flex items-center justify-center gap-2"><Bell size={16} className="text-[#d4af37]" /> {t("push.enable")}</button>}
    </div>
  );
}
